/**
 * @ Author: Housefolios
 * @ Create Time: 2021-09-16 13:21:50
 * @ Modified by: David Helmick
 * @ Modified time: 2023-01-30 16:30:47
 * @ Description: Page content that displays if a marketplace has no properties
 *
 * Refactored to use generic EmptyState component
 */

import React from 'react'
import { EmptyState } from '@/housefolios-components/shared'

export default function EmptyMarketplace(props) {
  const title = `No ${props.sold ? 'sold ' : ''}properties on this Marketplace`

  const description = `There are currently no ${props.sold ? 'sold ' : ''}houses listed on this Marketplace. Check again soon!`

  return (
    <EmptyState
      icon={['fas', 'sign-hanging']}
      title={title}
      description={description}
    />
  )
}
